export default __webpack_public_path__ + "static/color-spots-dark-8bb64913cebe5db5656e4df9bf9cf5c9f9d03952d4365c9b9df4fa113fdfc252.png";